export const CHECKOUT_LABELS = 'checkout';
export const GLOBAL_LABELS = 'global';

export const lblConfirmationOrderDetailsHeading = 'lbl_confirmation_orderDetails_heading';
export const lblConfirmationOrderDetailsHelpCenterText =
  'lbl_confirmation_orderDetails_helpCenter_text';
export const lblEarnedRewardText = 'lbl_earnedReward_text';
export const lblBannerConfirmationPlccPointsLabel1 = 'lbl_banner_confirmation_plcc_points_label1';
export const lblFallbackRewardText = 'lbl_fallbackReward_text';
export const lblUserRewardTxt = 'lbl_user_reward_txt';
export const lblNextRewardText = 'lbl_nextReward_text';
export const lblKeepShoppingRedesign = 'lbl_keep_shopping_redesign';
export const lblConfirmationNextHeading = 'lbl_confirmation_nextHeading';
export const lblConfirmationNextDetailsBoss = 'lbl_confirmation_nextDetails_boss';
export const lblConfirmationNextDetails = 'lbl_confirmation_nextDetails';
export const lblConfirmationUpdateOrderHeading = 'lbl_confirmation_updateOrderHeading';
export const lblEstimateToArrive = 'lbl_estimate_to_arrive';
export const lblConfirmationVenmoHeading = 'lbl_confirmation_venmo_heading';
export const lblSmsNotificationHeading1 = 'lbl_smsNotification_heading_1';
export const lblSmsNotificationHeading2 = 'lbl_smsNotification_heading_2';
export const lblSmsNotificationSubscribeSuccess = 'lbl_smsNotification_subscribeSuccess';
export const lblSmsNotificationJoinNowBtn = 'lbl_smsNotification_joinNow_btn';
export const lblSmsNotificationPhoneLbl = 'lbl_smsNotification_phone_lbl';
export const lblReferAFriendHeadingForFriend = 'lbl_refer_a_friend_heading_for_friend';
export const lblReferAFriendHeadingForYou = 'lbl_refer_a_friend_heading_for_you';
export const lblReferAFriendBtnText = 'lbl_refer_a_friend_btn_text';
export const lblOdmCouponsHeading1 = 'lbl_odmCoupons_heading_1';
export const lblOdmCouponsHeading2 = 'lbl_odmCoupons_heading_2';

export const lblConfirmationOrderNumberMsg = 'lbl_confirmation_orderNumberMsg';
export const lblConfirmationOrderNumberMsgNew = 'lbl_confirmation_orderNumberMsgNew';
export const lblConfirmationMixOrderMsg1 = 'lbl_confirmation_mixOrderMsg1';
export const lblConfirmationMixOrderMsg2 = 'lbl_confirmation_mixOrderMsg2';
export const lblConfirmationOrderMsg1 = 'lbl_confirmation_orderMsg1';
export const lblConfirmationShippingMsg = 'lbl_confirmation_shippingMsg';
export const lblConfirmationPickup = 'lbl_confirmation_pickup';
export const lblConfirmationOrderMsg2 = 'lbl_confirmation_orderMsg2';
export const lblConfirmationHeading = 'lbl_confirmation_heading';

export const lblOdmCouponsWebCode = 'lbl_odmCoupons_webCode';
export const lblPrintIcon = 'lbl_print_icon';
export const lblUpArrowIcon = 'lbl_up_arrow_icon';
export const lblDownArrowIcon = 'lbl_down_arrow_icon';
export const lblOdmCouponsValidTill = 'lbl_odmCoupons_validTill';
export const lblOdmCouponsNowThrough = 'lbl_odmCoupons_nowThrough';

export const lblConfirmationOrderNumber = 'lbl_confirmation_orderNumber';
export const lblConfirmationOrderDate = 'lbl_confirmation_orderDate';
export const lblConfirmationOrderDetailsItemCount = 'lbl_confirmation_orderDetails_itemCount';
export const lblConfirmationOrderTotal = 'lbl_confirmation_orderTotal';

export const lblConfirmationShippingTo = 'lbl_confirmation_shippingTo';

export const lblConfirmationToday = 'lbl_confirmation_today';
export const lblConfirmationTomorrow = 'lbl_confirmation_tomorrow';
export const lblConfirmationPhone = 'lbl_confirmation_phone';
export const lblConfirmationBopisDate = 'lbl_confirmation_bopisDate';
export const lblConfirmationPickupAt = 'lbl_confirmation_pickupAt';
export const lblConfirmationItem = 'lbl_confirmation_item';

export const lblInfoIcon = 'lbl_info_icon';
export const lblPickupIcon = 'lbl_pickup_icon';
export const lblShippingIcon = 'lbl_shipping_icon';

export const lblBrandLogoTcpAltText = `lbl_brandlogo_tcpAltText`;
export const lblBrandLogoGymAltText = `lbl_brandlogo_gymAltText`;
export const lblBrandLogoSnjAltText = `lbl_brandlogo_snjAltText`;
export const lblBrandLogoPjpAltText = `lbl_brandlogo_pjpAltText`;

const ConfirmationLabels = {
  checkout: {
    bagPage: {
      [lblBannerConfirmationPlccPointsLabel1]:
        'YOU EARNED #estimatedRewardsVal# POINTS ON THIS PURCHASE!',
      [lblEstimateToArrive]: 'Estimated to arrive by',
    },
    orderConfirmation: {
      [lblConfirmationOrderDetailsHeading]: 'Order Details',
      [lblConfirmationOrderDetailsHelpCenterText]:
        '<style>p{font-size:14px; font-family: Nunito;}a{color:black;}</style><p>If you have questions about your order, <a href="/us/help-center/faq" title="Help Center" target="_blank">visit the help center</a> to learn more.',
      [lblConfirmationNextHeading]: "What's next?",
      [lblConfirmationNextDetailsBoss]:
        "Check your email for your order confirmation. We'll also let you know when this order is ready for pickup. You will receive separate credit card charges for the items being shipped and items being picked up in store.",
      [lblConfirmationNextDetails]:
        "Check your email for your order confirmation. We'll also let you know when your order is ready for pickup. You will receive separate credit card charges for online and pickup orders.",
      [lblConfirmationUpdateOrderHeading]: 'Can I update my order?',
      [lblConfirmationVenmoHeading]: 'Venmo Payment',
      [lblSmsNotificationHeading1]: 'Join Our Text Alerts',
      [lblSmsNotificationHeading2]: 'Stay updated on special promos & new arrivals.',
      [lblSmsNotificationSubscribeSuccess]: 'Thank you for joining our list!',
      [lblSmsNotificationJoinNowBtn]: 'JOIN NOW',
      [lblSmsNotificationPhoneLbl]: 'Enter Phone Number',
      [lblReferAFriendHeadingForFriend]: '$10 for a friend',
      [lblReferAFriendHeadingForYou]: '$10 for you!',
      [lblReferAFriendBtnText]: 'Refer a Friend',
      [lblOdmCouponsHeading1]: 'Special Coupons just for you!',
      [lblOdmCouponsHeading2]: '(Coupon(s) will also be included in your oder emails.)',
      [lblConfirmationOrderNumberMsg]: 'Your order number is #orderNumber',
      [lblConfirmationOrderNumberMsgNew]: 'Your order numbers are #orderNumber',

      [lblConfirmationMixOrderMsg1]:
        "You'll receive emails confirming your pickup status and order info at ",
      [lblConfirmationMixOrderMsg2]:
        '.If a different email address was provided for pickup, status updates will be sent to that email instead.',
      [lblConfirmationOrderMsg1]: "You'll receive an email confirmation shortly with",
      [lblConfirmationShippingMsg]: 'your order',
      [lblConfirmationPickup]: 'pickup',
      [lblConfirmationOrderMsg2]: 'info at',
      [lblConfirmationHeading]: 'Thank You #customerName for your order!',
      [lblOdmCouponsWebCode]: 'WEB CODE:',
      [lblOdmCouponsValidTill]: 'Valid ',
      [lblOdmCouponsNowThrough]: 'Now through',
      [lblConfirmationShippingTo]: 'Shipping to',
      [lblConfirmationToday]: 'Today',
      [lblConfirmationTomorrow]: 'Tomorrow',
      [lblConfirmationPhone]: 'Phone',
      [lblConfirmationBopisDate]: 'Today, ',
      [lblConfirmationPickupAt]: 'Pickup at',
      [lblConfirmationItem]: 'ITEM',
      [lblConfirmationOrderNumber]: 'Order #',
      [lblConfirmationOrderDate]: 'Order Date',
      [lblConfirmationOrderDetailsItemCount]: 'Item Count',
      [lblConfirmationOrderTotal]: 'Order Total',
    },
  },

  global: {
    header: {
      [lblEarnedRewardText]: 'CONGRATULATIONS YOU HAVE EARNED #estimatedRewardsVal# REWARD',
      [lblFallbackRewardText]: 'YOU HAVE EARNED POINTS ON THIS PURCHASE!',
      [lblUserRewardTxt]: "You're #estimatedRewardsVal# #descVal#",
      [lblNextRewardText]: ' points away from earning your next reward.',
    },
    addedToBagModal: {
      [lblKeepShoppingRedesign]: 'Keep Shopping',
    },
    accessibility: {
      [lblPrintIcon]: 'Print icon',
      [lblUpArrowIcon]: 'Up arrow Icon',
      [lblDownArrowIcon]: 'Down arrow icon',
      [lblInfoIcon]: 'Info icon',
      [lblPickupIcon]: 'pickup icon',
      [lblShippingIcon]: 'shipping icon',
      [lblBrandLogoTcpAltText]: `The Children's Place logo | Click to visit The Children's Place Website`,
      [lblBrandLogoGymAltText]: 'Gymboree logo | Click to visit Gymboree Website',
      [lblBrandLogoSnjAltText]: 'Sugar and Jade logo | Click to visit Sugar and Jade Website',
      [lblBrandLogoPjpAltText]: 'PJ Place logo | Click to visit PJ Place Website',
    },
  },
};
export default ConfirmationLabels;
